// Smart door lock. Validates a 4-digit PIN against the logged-in user's password
// locally (the security gate is client-side, same as the Flutter app), then
// publishes the unlock command (OPENDOOR on 3, LOCKUNLOCK on 102).
// Fewer clicks (2026-10-20): on lock 3 the 4th correct digit opens it (as the
// phone keypad does); 102 keeps its button. "Sent" is a toast, not a box.

import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import DeviceShell from '../../components/DeviceShell';
import { useApp } from '../../../../core/state/AppContext';
import { publishCommand } from '../../../../core/utils/deviceController';
import { unlockCommand, unlockLabel, ROOM_DOOR_LOCK_ID } from '../../../../core/devices/deviceMeta';
import { showToast } from '../../../shared/toast';

export default function DoorScreen({ device }) {
  const { userId, user } = useApp();
  const uno = device.UniqueNumber;
  const [pin, setPin] = useState('');
  const [msg, setMsg] = useState(null);
  const explicitButton = Number(device.DeviceID) === ROOM_DOOR_LOCK_ID;

  const open = (entered = pin) => {
    if (entered === String(user?.Password)) {
      publishCommand(uno, unlockCommand(device.DeviceID), userId);
      setMsg(null);
      showToast('Unlock sent to the lock', { severity: 'success' });
    } else {
      setMsg({ type: 'error', text: 'Incorrect PIN.' });
    }
    setPin('');
  };

  const type = (v) => {
    const next = v.replace(/\D/g, '').slice(0, 4);
    setPin(next);
    if (next.length === 4 && !explicitButton) open(next);
  };

  return (
    <DeviceShell title={device.DeviceName || uno}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 4 }}>
        <LockOpenIcon sx={{ fontSize: 80, color: 'text.primary' }} />
        <Typography color="text.primary">Enter your PIN to unlock</Typography>
        {msg && <Alert severity={msg.type} sx={{ width: '100%', maxWidth: 320 }}>{msg.text}</Alert>}
        <TextField type="password" value={pin} label="PIN"
          onChange={(e) => type(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && open()}
          autoFocus
          inputProps={{ inputMode: 'numeric', maxLength: 4 }}
          sx={{ width: '100%', maxWidth: 320 }} />
        <Button variant="contained" onClick={() => open()} sx={{ width: '100%', maxWidth: 320, py: 1.5 }}>
          {unlockLabel(device.DeviceID)}
        </Button>
      </Box>
    </DeviceShell>
  );
}
